const $toTop = $('.js-to-top');
const $window = $(window);

const STUCK_CLASS = 'is-stuck';
const ACTIVE_CLASS = 'is-active';
const SHOW_OFFSET = 300;

const toTop = {
  initialize() {
    this.onResize();
    this.check();

    window.addEventListener('scroll', () => {
      this.check();
    }, {
      passive: true,
    });

    $window.on('resize', () => {
      this.onResize();
    });

    $toTop.on('click', () => {
      $('body, html').animate({ scrollTop: 0 });
    });
  },

  /**
   * Check which classes to add to the element
   * @return {void}
   */
  check() {
    // Get the current scroll position
    const top = $window.scrollTop();

    // Check if we hit the footer
    const isHit = (top + this.windowHeight) > this.footerOffset;

    // Check if the element should be visibile
    const isVisible = (top > SHOW_OFFSET);

    // Add classes for making it stick to the footer
    if (isHit && !$toTop.hasClass(STUCK_CLASS)) {
      $toTop.addClass(STUCK_CLASS);
    } else if (!isHit && $toTop.hasClass(STUCK_CLASS)) {
      $toTop.removeClass(STUCK_CLASS);
    }

    // Add classes to make the button visible
    if (isVisible && !$toTop.hasClass(ACTIVE_CLASS)) {
      $toTop.addClass(ACTIVE_CLASS);
    } else if (!isVisible && $toTop.hasClass(ACTIVE_CLASS)) {
      $toTop.removeClass(ACTIVE_CLASS);
    }
  },

  /**
   * Save a few variables on the object on resize. This prevents the
   * recalculation of variables on scroll, making it faster in the process
   * @return {void}
   */
  onResize() {
    const $footer = $('.footer');
    this.windowHeight = $window.height();
    this.footerOffset = $footer.length ? $footer.offset().top : 0;
  },
};

export default toTop;
